<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import BinaryRowView from "./BinaryRowView.svelte";
    import {UrlUtil} from "../../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../../lib/Common/Http/HttpRequestUtil";
    import LoadingContentView from "../../../../component/common/Loading/LoadingContentView.svelte";
    import ArraySlotView from "../../../../component/common/Value/ArraySlotView.svelte";
    import BinaryEditDialogView from "./BinaryEditDialogView.svelte";
    import AddButtonView from "../../../../component/common/Button/AddButtonView.svelte";
    import BinaryTagAddDialogView from "./Tag/BinaryTagAddDialogView.svelte";
    import {ValueUtil} from "../../../../lib/Common/Value/ValueUtil";
    import {BinaryTable} from "../../../../lib/Table/BinaryTable";

    const dispatcher = createEventDispatcher();

    export let space;
    export let app;
    export let filterMap;

    $: {
        loadData(filterMap);
    }

    let isLoading = false;
    let binaries = null;
    let editData = null;
    let addTagBinary = null;


    onMount(() => {
    });


    function loadData(filterMap: {}) {
        const paramMap = {};
        paramMap['space_id'] = space.id;
        paramMap['app_id'] = app.id;

        paramMap['include_binary_tags'] = undefined;
        paramMap['include_binary_tags_tag'] = undefined;
        paramMap['with_download_key'] = undefined;

        console.log({filterMap});

        if ('binary_name' in filterMap) {
            const binaryName = filterMap['binary_name'];
            paramMap['name'] = `%${binaryName}%`;
        }
        if ('binary_type' in filterMap) {
            const binaryType = filterMap['binary_type'];
            if (binaryType != null) {
                paramMap['type'] = binaryType;
            }
        }
        if ('binary_platform_type' in filterMap) {
            const binaryPlatformType = filterMap['binary_platform_type'];
            if (binaryPlatformType != null) {
                paramMap['platform_type'] = binaryPlatformType;
            }
        }

        if ('description' in filterMap) {
            const description = filterMap['description'];
            paramMap['description'] = `%${description}%`;
        }

        if ('binary_tag_names' in filterMap) {
            let binaryTagNames = filterMap['binary_tag_names'];
            binaryTagNames = binaryTagNames.trim();
            binaryTagNames = binaryTagNames.replaceAll('　', ' ');
            const binaryTagNameArray = binaryTagNames.split(' ').filter(value => !ValueUtil.isEmpty(value));
            binaryTagNames = binaryTagNameArray.join(',');
            paramMap['tag_names'] = binaryTagNames;
        }

        if ('auto_delete_type' in filterMap) {
            const autoDeleteType = filterMap['auto_delete_type'];
            if (autoDeleteType != null) {
                paramMap['auto_delete_type'] = autoDeleteType;
            }
        }

        paramMap['order_by'] = 'updated_at:desc';
        paramMap['limit'] = 100; // 最大100件表示

        const url = UrlUtil.createApiUrl("binary", paramMap);

        isLoading = true;
        HttpRequestUtil.getRequest(url, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];
            binaries = body['binaries'];


        });
    }

    function onEditBinary(event) {
        const binary = event.detail.binary;
        editData = {...binary};
    }


    function onClickAddBinary() {
        editData = {
            space_id: space.id,
            app_id: app.id,
            type: BinaryTable.Type.Application,
            platform_type: null,
        };
    }

    function onOpenAddBinaryTag(event) {
        const binary = event.detail.binary;
        addTagBinary = binary;
    }

    function onUpdate() {
        loadData(filterMap);
        dispatcher('update');
    }


</script>

<div class="binary-list-view">
    <LoadingContentView isLoading={isLoading}>
        <div class="add-button-area">
            <AddButtonView on:click={onClickAddBinary}/>
        </div>

        <div class="binary-area">
            <ArraySlotView array={binaries} dataName="バイナリ">
                <div class="tips-area">
                    {binaries.length}件、表示しています。(検索対象中の最新更新日時順。最大100件)
                </div>
                <table class="small">
                    <thead>
                    <tr>
                        <th></th>
                        <th>バイナリ名</th>
                        <th class="">Install QR</th>
                        <th>説明</th>
                        <th>詳細情報</th>

                    </tr>

                    </thead>
                    <tbody>
                    {#each binaries as binary}
                        <BinaryRowView space={space} app={app} binary={binary}
                                       on:edit={onEditBinary} on:update={onUpdate}
                                       on:openAddBinaryTag={onOpenAddBinaryTag}
                        />
                    {/each}
                    </tbody>
                </table>
            </ArraySlotView>

        </div>

        <div class="add-button-area">
            <AddButtonView on:click={onClickAddBinary}/>
        </div>

    </LoadingContentView>


</div>

<BinaryEditDialogView
        space={space}
        app={app}
        editData={editData}
        on:update={onUpdate}
        on:close={()=>{
            editData = null;
        }}
/>

<BinaryTagAddDialogView
        binary={addTagBinary}
        on:update={onUpdate}
        on:close={()=>{
            addTagBinary = null;
        }}
/>


<style lang="scss">
    .binary-list-view {
        .tips-area {
            font-size: 0.75em;
            opacity: 0.75;
        }

        table {
            height: 100%;
        }

        .add-button-area {
            margin-top: 60px;
            text-align: right;
        }

        .binary-area {
            margin-top: 60px;
        }
    }
</style>